/**
 * @desc 查询会员分页列表
 */
import {
  PageMemberPageItem,
  MemberPageQuery
} from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryMemberPageParameter = MemberPageQuery

const method = 'GET'
const url = '/auth/operation/member/page'

export const queryMemberPageApi = (
  params?: QueryMemberPageParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<PageMemberPageItem>({
    method,
    url,
    params,
    ...config
  })
}

queryMemberPageApi.method = method
queryMemberPageApi.url = url
